import {
  ListItemIcon as ListItemIconMui,
  ListItemIconProps as ListItemIconPropsMui,
} from '@mui/material';

export type ListItemIconProps = ListItemIconPropsMui;

export function ListItemIcon({ ...rest }: ListItemIconProps) {
  return <ListItemIconMui {...rest} />;
}
